import { t } from "@lingui/macro";
import { Box, Container } from "@mui/material";
import { useDeviceSettings } from "./useDeviceSettings";
import { MenuList, WfIconNavigationCloseRegular } from "@WahooFitness/redesignr";
import WorkoutProfilesAlert from "./WorkoutProfilesAlert";
import useNavUpOnDeviceDisconnect from "./useNavUpOnDeviceDisconnect";
import {
  ErrorBoundary,
  GlobalHeader,
  hasMinProfile,
  useUserContext,
} from "@WahooFitness/wahoo-offline-mfe";
import { Profile } from "@WahooFitness/cloud-client-types";
import useDrawerPresentation from "@/hooks/useDrawerPresentation";

const DeviceSettings = ({ appToken }: { appToken: string }) => {
  const {
    configItems,
    configError,
    configIsLoading,
    reloadConfig,
    showWorkoutProfilesAlert,
    onCloseWorkoutProfilesAlert,
  } = useDeviceSettings(appToken);
  const { currentUser } = useUserContext();
  const { isDrawer, close } = useDrawerPresentation("deviceSettings");

  useNavUpOnDeviceDisconnect(appToken);

  return (
    <>
      <GlobalHeader
        title={t`All Settings`}
        primaryLeftActionItem={
          isDrawer ? { icon: <WfIconNavigationCloseRegular />, action: close } : undefined
        }
        backAction={isDrawer ? close : undefined}
      />
      <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
        <Box height="100%" width="100%" display="flex" flexDirection="column" overflow="hidden">
          <ErrorBoundary
            error={configError}
            isLoading={configIsLoading}
            onReload={reloadConfig}
            showError={hasMinProfile(Profile.alpha, currentUser?.app?.profile)}
          >
            {showWorkoutProfilesAlert && (
              <WorkoutProfilesAlert onClose={onCloseWorkoutProfilesAlert} />
            )}
            <Box
              display="flex"
              flexDirection="column"
              pb={2}
              pt={1}
              height="100%"
              overflow="scroll"
              gap={4}
            >
              {configItems
                .filter((section) => !section.hidden && section.items.some((item) => !item.hidden))
                .map((section) => (
                  <Box key={section.name}>
                    <MenuList
                      title={section.name}
                      listItems={section.items}
                      hidden={section.hidden}
                    />
                    {section.bottomContent && <Box px={4}>{section.bottomContent}</Box>}
                  </Box>
                ))}
            </Box>
          </ErrorBoundary>
        </Box>
      </Container>
    </>
  );
};

export { DeviceSettings };
